<template>
  <div
    class="bg-white p-5vw md:p-3vw"
    v-html="post.body"
  />
</template>

<script>
export default {
  name: 'Article',

  props: {
    post: {
      type: Object,
      default: () => {}
    }
  }
}
</script>

<style>
p a {
  color: var(--color-primary);
  text-decoration: underline;
}
</style>
